export default "__VITE_ASSET__BfLpv3wC__"